import script from "./el-datepicker-shortcut.vue?vue&type=script&lang=js"
export * from "./el-datepicker-shortcut.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__